import React from 'react'
import './collections_sub.css'
import Footer from '../../Home/Home_modules/Footerr/footer'
import topbanner from './Im/kabalibanner.jpg'
import topimg from './Im/kabalithumb.jpg'
import sharebtn from './Im/sharebtn2.png'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Cards_kabali from '../../Home/Home_modules/cards_kabali';


function Kabali() {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          partialVisibilityGutter: 30
        }
      };
    return (
        <div>
            <div className="collections-sub-top">
                <img src={topbanner} />
            </div>
            <div className="collections-sub-top2">
                <img src={topimg} />
                <h1>Kabali</h1>
                <p>Kabali is a 2016 Indian Tamil-language action drama film produced by Kalaipuli S. Thanu. The film stars Rajinikanth and contains iconic signature dialogues and scenes from Rajinikanth. The movie collected over 300 crores at the box office.</p>
                <div className="collections-sub-topbtns">
                <button className="collections-sub-sharebtn"><i className="fas fa-share"></i></button><button className="collections-sub-sharebtn"><i className="fas fa-ellipsis-h"></i></button>
                </div>
            </div>
            <div className="explore">
              
           <div className="collection-explore-d">
           <Cards_kabali />
</div>





</div>
        <Footer/>
        </div>
    )
}

export default Kabali
